<template>
  <div>
    <ressource code="description-problematiques"></ressource>
    <data-iterator
      :list="servicesOfferts"
      add-new-text="Ajouter une problématique"
      :live="{ endpoint: 'sas-services-offerts', sasId: sas.id }"
      :icon="$getIcon('services')"
      optional
      :valids="valids"
      ref="dataIterator"
    >
      <template v-slot:show-mode="{ item }">
        <h3 class="mb-3">{{ item.problematique ? getCatalogueValueById(9422, item.problematique).text : "" }}</h3>
        <div>
          <v-chip color="primary" outlined class="mb-2 mr-2" v-for="service in item.servicesOfferts" :key="service">{{
            service ? (getCatalogueValueById(3103, service) ? getCatalogueValueById(3103, service).text : "Service inconnu") : ""
          }}</v-chip>
        </div>
      </template>
      <template v-slot:edit-mode="{ item }">
        <opq-catalogue
          code="problematique"
          v-model="item.problematique"
          orderBy="text"
          :live="liveSasServicesOfferts(3102, item)"
          :filter="
            (fd) =>
              servicesOfferts
                .filter((s) => s.id != item.id)
                .map((s) => s.problematique)
                .indexOf(fd.value) == -1
          "
          :code-exclude="[...sas.limitations.problematiques, ...sas.problematiquesInaccessibles]"
          @eudo-updated="checkLimitationsServicesOfferts(item)"
        ></opq-catalogue>

        <opq-catalogue
          code="service-offert"
          v-model="item.servicesOfferts"
          :live="liveSasServicesOfferts(3103, item)"
          :code-exclude="[
            ...limitations.servicesOfferts,
            ...sas.servicesOffertsInaccessibles,
            ...limitationsServicesOffertsParProblematique(item),
            { code: '04 PST', condition: estNon(sas.sasRenseignementsProfessionnels.exercezVousLaPsychotherapie) },
            { code: '03', condition: estNonNeuropsy(sas.sasRenseignementsProfessionnels.evaluezVousLesTroublesNeuropsychologiques) }
          ]"
          :ref="'serviceOffert' + item.id"
        ></opq-catalogue>
      </template>
    </data-iterator>
  </div>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import { bus } from "@/plugins/bus"
export default {
  mixins: [CataloguesHelper],
  props: {
    servicesOfferts: { type: Array },
    sas: { type: Object, required: true },
    limitations: { type: Object },
    valids: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  created() {
    bus.$on("exercicePsychotherapiePasseANon", this.exercicePsychotherapiePasseANon)
  },
  methods: {
    liveSasServicesOfferts(cle, item) {
      return { endpoint: "sas-services-offerts", cle: cle, fileId: item.id }
    },
    limitationsServicesOffertsParProblematique(item) {
      let found = this.limitations.servicesOffertsParProblematique.find((x) => x.cle == item.problematique)
      if (found) {
        return found.conditions
      }
      return []
    },
    checkLimitationsServicesOfferts(item) {
      let limitationsServicesOffertsParProblematique = this.limitationsServicesOffertsParProblematique(item)
      let serviceOffertRef = this.$refs["serviceOffert" + item.id]
      let codes = limitationsServicesOffertsParProblematique.map((x) => x.code)
      serviceOffertRef.removeValuesByCodes(codes)
    },
    exercicePsychotherapiePasseANon() {
      let servicesToUpdate = this.servicesOfferts.filter(
        (so) => so.servicesOfferts.findIndex((s) => this.getCatalogueCodeById(3103, s) == "04 PST") > -1
      )
      servicesToUpdate.forEach((serviceOffert) => {
        this.$refs["serviceOffert" + serviceOffert.id].removeValuesByCodes(["04 PST"])
      })
    }
  }
}
</script>

<style>
</style>